import React from "react";
import IconButton from "@material-ui/core/IconButton";
import FormLabel from "@material-ui/core/FormLabel";
import useStyles from "./styles/IconOnlyButton";
import clsx from "clsx";

export type ButtonSize = "xl" | "lg" | "md" | "sm";
export type ButtonType =
  | "gray"
  | "gray_line"
  | "cool_line"
  | "primary"
  | "primary_line"
  | "gray_fill";

export type IconOnlyButtonProps = {
  customId?: string;
  buttonSize?: ButtonSize;
  buttonType?: ButtonType;
  radius?: "rect" | "circle";
  disabled?: boolean;
  className?: string;
  dataTestid?: string;
  onClick?: (evt: React.MouseEvent<HTMLElement>) => void;
  htmlFor?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  ariaLabel?: string;
};

const IconOnlyButton: React.FC<IconOnlyButtonProps> = ({
  customId,
  buttonSize = "lg",
  buttonType = "gray",
  radius,
  disabled,
  className,
  dataTestid,
  onClick,
  htmlFor,
  children,
  style,
  ariaLabel,
}) => {
  const classes = useStyles();

  const sizeClasses: Record<ButtonSize, string> = {
    xl: classes.btn_xl,
    lg: classes.btn_lg,
    md: classes.btn_md,
    sm: classes.btn_sm,
  };

  const colorClasses: Record<ButtonType, string> = {
    gray: classes.gray,
    gray_fill: classes.gray_fill,
    gray_line: classes.gray_line,
    cool_line: classes.cool_line,
    primary: classes.primary,
    primary_line: classes.primary_line,
  };

  const component =
    htmlFor && !disabled ? { component: FormLabel, htmlFor } : {};

  return (
    <IconButton
      {...component}
      disableRipple
      id={customId}
      data-testid={dataTestid}
      disabled={disabled}
      onClick={onClick}
      className={clsx(
        classes.btn_base,
        radius === "rect" && classes.btn_rect,
        className,
        sizeClasses[buttonSize],
        colorClasses[buttonType]
      )}
      style={style}
      aria-label={ariaLabel}
    >
      {children}
    </IconButton>
  );
};

export default IconOnlyButton;
